import { createSlice } from '@reduxjs/toolkit';



const initialState = {
  askToDelete: false,
  deletingItemUrl: null,
  refetchKey: null,
  itemName: null,

  successOperation: false,
  successText: null,
};


export const helperModalsSlice = createSlice({
  name: "helperModals",
  initialState,
  reducers: {
    changeAskToDelete: (state, action) => {
      state.askToDelete = !state.askToDelete;
    },
    changeDeletingItemUrl: (state, action) => {
      state.deletingItemUrl = action.payload;
    },
    changeItemName: (state, action) => {
      state.itemName = action.payload;
    },
    changeRefetchKey: (state, action) => {
      state.refetchKey = action.payload;
    },
    changeSuccessOperation: (state, action) => {
      state.successOperation = !state.successOperation;
    },
    changeSuccessText: (state, action) => {
      state.successText = action.payload;
    },
    resetHelperModals: () => initialState
  }
});

export const {
  changeAskToDelete,
  changeItemName,
  changeDeletingItemUrl,
  changeRefetchKey,
  resetHelperModals,
  changeSuccessOperation,
  changeSuccessText,
} = helperModalsSlice.actions;

export default helperModalsSlice.reducer;